import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Container, Form, Row, Col } from 'react-bootstrap';
import { FaEdit, FaTrash, FaAngleRight, FaAngleLeft } from 'react-icons/fa';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Multiselect from 'multiselect-react-dropdown';
import Cookies from 'universal-cookie';
import './Activities.css';

function Activities() {
    const [AddActivity, setAddActivity] = useState(false);
    const [activities, setActivities] = useState([]);
    const [filteredActivities, setFilteredActivities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [collapsedRows, setCollapsedRows] = useState({});
    const [customerCareTypes, setCustomerCareTypes] = useState([])
    const [newActivity, setNewActivity] = useState({
        ActivityName: '',
        CustomerCareTypeID: '',
        GeneralCategory: '',
        Frequency: '',
        SN_HoursDay: '',
        SN_HoursNight: '',
        ENA_HoursDay: '',
        ENA_HoursNight: '',
        CW_HoursDay: '',
        CW_HoursNight: '',
        BenefitBody: '',
        BenefitMind: '',
        BenefitSocial: '',
        DateFrom: '',
        DateTo: '',
    });

    useEffect(() => {
        fetchActivities();
        fetchCustomerCareTypes();
    }, []);

    const fetchCustomerCareTypes = async () => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/customerCareTypes', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            if (response.ok) {
                const data = await response.json();
                if (Array.isArray(data)) {
                    const updatedCareTypes = data.map(element => ({
                        name: element.Name,
                        id: element.CareTypeID
                    }));

                    setCustomerCareTypes(updatedCareTypes);
                } else {
                    console.error("Error: Expected an array but received", data);
                }

            } else {
                console.error('Failed to fetch customer care types');
            }
        } catch (error) {
            console.error('An error occurred while fetching customer care types:', error);
        }
    };

    const handleSort = (key, isDate = false) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        const sortedData = [...filteredActivities].sort((a, b) => {
            if (isDate) {
                return direction === 'ascending'
                    ? new Date(a[key]) - new Date(b[key])
                    : new Date(b[key]) - new Date(a[key]);
            } else {
                return direction === 'ascending'
                    ? a[key].toString().localeCompare(b[key].toString())
                    : b[key].toString().localeCompare(a[key].toString());
            }
        });

        setFilteredActivities(sortedData);
        setSortConfig({ key, direction });
    };

    const getSortIndicator = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? ' ↑' : ' ↓';
        }
        return '';
    };

    const fetchActivities = async () => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        console.log(token)
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/careitemactivities', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            const data = await response.json();
            console.log('Response:', data);
            setActivities(data);
            setFilteredActivities(data);
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = activities.filter(activity =>
            activity.ActivityName.toLowerCase().includes(value)
        );
        setFilteredActivities(filtered);
    };

    const toggleRowCollapse = (activityId) => {
        setCollapsedRows(prevState => ({
            ...prevState,
            [activityId]: !prevState[activityId],
        }));
    };

    const handleAddActivity = async () => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        if (newActivity.BenefitBody + newActivity.BenefitMind + newActivity.BenefitSocial > 100) {
            alert('Your benifit percantages exceed 100%')
        }
        try {
            const response = await fetch('https://api.cpq.yourcrm.co.za/api/careitemactivities', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(newActivity),
            });

            if (response.ok) {
                fetchActivities();
                setAddActivity(false);
                setNewActivity({
                    ActivityName: '',
                    CustomerCareTypeID: '',
                    GeneralCategory: '',
                    Frequency: '',
                    SN_HoursDay: '',
                    SN_HoursNight: '',
                    ENA_HoursDay: '',
                    ENA_HoursNight: '',
                    CW_HoursDay: '',
                    CW_HoursNight: '',
                    BenefitBody: '',
                    BenefitMind: '',
                    BenefitSocial: '',
                    DateFrom: '',
                    DateTo: '',
                });
            } else {
                console.error('Failed to add activity');
            }
        } catch (error) {
            console.error('Error adding activity:', error);
        }
    };

    function debounce(fn, delay) {
        let timeoutID;
        return (...args) => {
            if (timeoutID) {
                clearTimeout(timeoutID);
            }
            timeoutID = setTimeout(() => {
                fn(...args);
            }, delay);
        };
    }
    const handleEditActivityDebounced = debounce(async (ActivityID, updatedActivity, fetchActivities) => {
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/careitemactivities/${ActivityID}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedActivity),
            });

            if (response.ok) {
                fetchActivities();
            } else {
                console.error('Failed to update activity');
            }
        } catch (error) {
            console.error('Error updating activity:', error);
        }
    }, 50);


    const [editActivityId, setEditActivityId] = useState(null);
    const [formData, setFormData] = useState({
        ActivityName: '',
        CustomerCareTypeID: '',
        GeneralCategory: '',
        Frequency: '',
        SN_HoursDay: '',
        SN_HoursNight: '',
        ENA_HoursDay: '',
        ENA_HoursNight: '',
        CW_HoursDay: '',
        CW_HoursNight: '',
        BenefitBody: '',
        BenefitMind: '',
        BenefitSocial: '',
        DateFrom: '',
        DateTo: '',
    });
    const handleEditClick = (activity) => {
        setEditActivityId(activity.ActivityID);
        setFormData({ ...activity });
    };

    const handleSaveClick = async () => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/careitemactivities/${editActivityId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                fetchActivities();
                setEditActivityId(null);
            } else {
                console.error('Failed to update activity');
            }
        } catch (error) {
            console.error('Error updating activity:', error);
        }
    };




    const handleDeleteActivity = async (ActivityID) => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        try {
            const response = await fetch(`https://api.cpq.yourcrm.co.za/api/careitemactivities/${ActivityID}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.ok) {
                fetchActivities();
            } else {
                console.error('Failed to delete activity');
            }
        } catch (error) {
            console.error('Error deleting activity:', error);
        }
    };

    return (
        <div className="activities-container">
            <div className="search-bar-container">
                <Form.Control
                    type="text"
                    placeholder="Search by Activity Name..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="search-bar"
                />
            </div>
            <div className="table-controls">
                <Button variant="link" onClick={() => toggleRowCollapse('frequency')}>
                    {collapsedRows['frequency'] ? <FaAngleRight /> : <FaAngleLeft />}
                    {collapsedRows['frequency'] ? "Expand Columns" : "Collapse Columns"}
                </Button>
            </div>
            <div className="table-wrapper">
                <Table striped bordered hover>
                    <thead >
                        <tr>
                            <th >Actions</th>
                            <th onClick={() => handleSort('ActivityName')}>Activity Name{getSortIndicator('ActivityName')}</th>
                            <th onClick={() => handleSort('CustomerCareTypeID')}>Care Recipient Category ID{getSortIndicator('CustomerCareTypeID')}</th>
                            <th onClick={() => handleSort('GeneralCategory')}>General Category{getSortIndicator('GeneralCategory')}</th>
                            <th onClick={() => handleSort('Frequency')}>Frequency{getSortIndicator('Frequency')}</th>
                            {collapsedRows['frequency'] ? null : (
                                <>
                                    <th colSpan={2}>SN Hours</th>
                                    <th colSpan={2}>ENA Hours</th>
                                    <th colSpan={2}>CW Hours</th>
                                    <th colSpan={3}>Benefit %</th>
                                    <th onClick={() => handleSort('DateFrom', true)}>From{getSortIndicator('DateFrom')}</th>
                                    <th onClick={() => handleSort('DateTo', true)}>To{getSortIndicator('DateTo')}</th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th style={{ zIndex: 1, top: 39 }}></th>
                            <th style={{ zIndex: 1, top: 39 }}></th>
                            <th style={{ zIndex: 1, top: 39 }}></th>
                            <th style={{ zIndex: 1, top: 39 }}></th>
                            <th style={{ zIndex: 1, top: 39 }}></th>
                            {collapsedRows['frequency'] ? null : (
                                <>
                                    <th style={{ top: 39 }} onClick={() => handleSort('SN_HoursDay')}>Day{getSortIndicator('SN_HoursDay')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('SN_HoursNight')}>Night{getSortIndicator('SN_HoursNight')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('ENA_HoursDay')}>Day{getSortIndicator('ENA_HoursDay')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('ENA_HoursNight')}>Night{getSortIndicator('ENA_HoursNight')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('CW_HoursDay')}>Day{getSortIndicator('CW_HoursDay')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('CW_HoursNight')}>Night{getSortIndicator('CW_HoursNight')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('BenefitBody')}>Body{getSortIndicator('BenefitBody')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('BenefitMind')}>Mind{getSortIndicator('BenefitMind')}</th>
                                    <th style={{ top: 39 }} onClick={() => handleSort('BenefitSocial')}>Social{getSortIndicator('BenefitSocial')}</th>
                                    <th style={{ zIndex: 1, top: 39 }}></th>
                                    <th style={{ zIndex: 1, top: 39 }}></th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredActivities?.map(activity => (
                            <tr key={activity.ActivityID}>
                                <td style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Button variant="link" data-tooltip-id={`edit-tooltip-${activity.ActivityID}`}>
                                        <FaEdit
                                            style={{ color: '#007bff', fontSize: '1.2rem' }}
                                            onClick={() => handleEditClick(activity)}
                                        />
                                    </Button>
                                    <ReactTooltip style={{ zIndex: 1000 }} id={`edit-tooltip-${activity.ActivityID}`} place="top" content="Edit Activity" />

                                    <Button variant="link" data-tooltip-id={`delete-tooltip-${activity.ActivityID}`}>
                                        <FaTrash
                                            style={{ color: '#dc3545', fontSize: '1.2rem' }}
                                            onClick={() => {
                                                if (window.confirm("Are you sure you want to remove this item?")) {
                                                    handleDeleteActivity(activity.ActivityID)
                                                }
                                            }}
                                        />
                                    </Button>
                                    <ReactTooltip style={{ zIndex: 1000 }} id={`delete-tooltip-${activity.ActivityID}`} place="top" content="Delete Activity" />
                                </td>
                                <td>{activity.ActivityName}</td>
                                <td>{activity.CustomerCareTypeID?.split(", ").map(id => {
                                    const careType = customerCareTypes.find(type => type.id.toString() === id.trim());
                                    return careType ? careType.name : id;
                                }).join(", ")}</td>
                                <td>{activity.GeneralCategory}</td>
                                <td>{activity.Frequency}</td>
                                {collapsedRows['frequency'] ? null : (
                                    <>
                                        <td>{activity.SN_HoursDay}</td>
                                        <td>{activity.SN_HoursNight}</td>
                                        <td>{activity.ENA_HoursDay}</td>
                                        <td>{activity.ENA_HoursNight}</td>
                                        <td>{activity.CW_HoursDay}</td>
                                        <td>{activity.CW_HoursNight}</td>
                                        <td>{activity.BenefitBody}</td>
                                        <td>{activity.BenefitMind}</td>
                                        <td>{activity.BenefitSocial}</td>
                                        <td>{new Date(activity.DateFrom).toISOString().split('T')[0]}</td>
                                        <td>{new Date(activity.DateTo).toISOString().split('T')[0]}</td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Button className="add-activity-btn" onClick={() => setAddActivity(true)}>Add New Activity</Button>

            <Modal show={AddActivity} onHide={() => setAddActivity(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formActivityName">
                            <Form.Label>Activity Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.ActivityName}
                                onChange={(e) => setNewActivity({ ...newActivity, ActivityName: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCustomerCareTypeID">
                            <Form.Label>Care Recipient Category ID</Form.Label>
                            <Multiselect
                                options={customerCareTypes}
                                displayValue="name"
                                selectedValues={
                                    customerCareTypes.filter(item =>
                                        formData.CustomerCareTypeID?.split(", ").includes(item.id.toString())
                                    )
                                }
                                onSelect={(selectedList) => {
                                    const selectedIds = selectedList.map(item => item.id).join(", ");
                                    setNewActivity(prev => ({ ...prev, CustomerCareTypeID: selectedIds }));
                                }}
                                onRemove={(selectedList) => {
                                    const selectedIds = selectedList.map(item => item.id).join(", ");
                                    setNewActivity(prev => ({ ...prev, CustomerCareTypeID: selectedIds }));
                                }}
                            />
                        </Form.Group>
                        <Form.Group controlId="formGeneralCategory">
                            <Form.Label>General Category</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.GeneralCategory}
                                onChange={(e) => setNewActivity({ ...newActivity, GeneralCategory: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formFrequency">
                            <Form.Label>Frequency</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.Frequency}
                                onChange={(e) => setNewActivity({ ...newActivity, Frequency: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formSN_HoursDay">
                            <Form.Label>SN Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.SN_HoursDay}
                                onChange={(e) => setNewActivity({ ...newActivity, SN_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formSN_HoursNight">
                            <Form.Label>SN Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.SN_HoursNight}
                                onChange={(e) => setNewActivity({ ...newActivity, SN_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formENA_HoursDay">
                            <Form.Label>ENA Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.ENA_HoursDay}
                                onChange={(e) => setNewActivity({ ...newActivity, ENA_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formENA_HoursNight">
                            <Form.Label>ENA Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.ENA_HoursNight}
                                onChange={(e) => setNewActivity({ ...newActivity, ENA_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCW_HoursDay">
                            <Form.Label>CW Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.CW_HoursDay}
                                onChange={(e) => setNewActivity({ ...newActivity, CW_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formCW_HoursNight">
                            <Form.Label>CW Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.CW_HoursNight}
                                onChange={(e) => setNewActivity({ ...newActivity, CW_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBenefitBody">
                            <Form.Label>Benefit % Body</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.BenefitBody}
                                onChange={(e) => setNewActivity({ ...newActivity, BenefitBody: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBenefitMind">
                            <Form.Label>Benefit % Mind</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.BenefitMind}
                                onChange={(e) => setNewActivity({ ...newActivity, BenefitMind: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBenefitSocial">
                            <Form.Label>Benefit % Social</Form.Label>
                            <Form.Control
                                type="text"
                                value={newActivity.BenefitSocial}
                                onChange={(e) => setNewActivity({ ...newActivity, BenefitSocial: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formDateFrom">
                            <Form.Label>Date From</Form.Label>
                            <Form.Control
                                type="date"
                                value={newActivity.DateFrom}
                                onChange={(e) => setNewActivity({ ...newActivity, DateFrom: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formDateTo">
                            <Form.Label>Date To</Form.Label>
                            <Form.Control
                                type="date"
                                value={newActivity.DateTo}
                                onChange={(e) => setNewActivity({ ...newActivity, DateTo: e.target.value })}
                            />
                        </Form.Group>
                        <Button className='mt-4' variant="primary" onClick={handleAddActivity}>Add Activity</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <Modal show={editActivityId !== null} onHide={() => setEditActivityId(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formEditActivityName">
                            <Form.Label>Activity Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.ActivityName}
                                onChange={(e) => setFormData({ ...formData, ActivityName: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditCustomerCareTypeID">
                            <Form.Label>Customer Category ID</Form.Label>
                            {/* <Form.Control
                                type="text"
                                value={formData.CustomerCareTypeID}
                                onChange={(e) => setFormData({ ...formData, CustomerCareTypeID: e.target.value })}
                            /> */}
                            {console.log(customerCareTypes.filter(item =>
                                formData.CustomerCareTypeID?.split(",").includes(item.id.toString())
                            ))}
                            <Multiselect
                                options={customerCareTypes}
                                displayValue="name"
                                selectedValues={
                                    customerCareTypes.filter(item =>
                                        formData.CustomerCareTypeID?.split(", ").includes(item.id.toString())
                                    )
                                }
                                onSelect={(selectedList) => {
                                    const selectedIds = selectedList.map(item => item.id).join(", ");
                                    setFormData(prev => ({ ...prev, CustomerCareTypeID: selectedIds }));
                                }}
                                onRemove={(selectedList) => {
                                    const selectedIds = selectedList.map(item => item.id).join(", ");
                                    setFormData(prev => ({ ...prev, CustomerCareTypeID: selectedIds }));
                                }}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditGeneralCategory">
                            <Form.Label>General Category</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.GeneralCategory}
                                onChange={(e) => setFormData({ ...formData, GeneralCategory: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditFrequency">
                            <Form.Label>Frequency</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.Frequency}
                                onChange={(e) => setFormData({ ...formData, Frequency: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditSN_HoursDay">
                            <Form.Label>SN Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.SN_HoursDay}
                                onChange={(e) => setFormData({ ...formData, SN_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditSN_HoursNight">
                            <Form.Label>SN Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.SN_HoursNight}
                                onChange={(e) => setFormData({ ...formData, SN_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditENA_HoursDay">
                            <Form.Label>ENA Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.ENA_HoursDay}
                                onChange={(e) => setFormData({ ...formData, ENA_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditENA_HoursNight">
                            <Form.Label>ENA Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.ENA_HoursNight}
                                onChange={(e) => setFormData({ ...formData, ENA_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditCW_HoursDay">
                            <Form.Label>CW Hours Day</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.CW_HoursDay}
                                onChange={(e) => setFormData({ ...formData, CW_HoursDay: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditCW_HoursNight">
                            <Form.Label>CW Hours Night</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.CW_HoursNight}
                                onChange={(e) => setFormData({ ...formData, CW_HoursNight: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditBenefitBody">
                            <Form.Label>Benefit % Body</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.BenefitBody}
                                onChange={(e) => setFormData({ ...formData, BenefitBody: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditBenefitMind">
                            <Form.Label>Benefit % Mind</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.BenefitMind}
                                onChange={(e) => setFormData({ ...formData, BenefitMind: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditBenefitSocial">
                            <Form.Label>Benefit % Social</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.BenefitSocial}
                                onChange={(e) => setFormData({ ...formData, BenefitSocial: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditDateFrom">
                            <Form.Label>Date From</Form.Label>
                            <Form.Control
                                type="date"
                                value={formData.DateFrom}
                                onChange={(e) => setFormData({ ...formData, DateFrom: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formEditDateTo">
                            <Form.Label>Date To</Form.Label>
                            <Form.Control
                                type="date"
                                value={formData.DateTo}
                                onChange={(e) => setFormData({ ...formData, DateTo: e.target.value })}
                            />
                        </Form.Group>
                        <Button variant="primary" onClick={handleSaveClick}>Save Changes</Button>
                    </Form>
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default Activities;
